{
  "list": {
    "searchLessons": "Search lessons",
    "searchEvidence": "Search evidence",
    "placeholderLessons": "Find a lesson, symptom, or incident",
    "placeholderEvidence": "Find a source, symptom, or incident",
    "allRecords": "All records",
    "lifecycle": "Lifecycle",
    "allStatuses": "All statuses",
    "exploreEvidence": "Explore evidence",
    "apply": "Apply",
    "groupByFeed": "Group by category",
    "view": "View",
    "expandFeed": "Show records in {{feed}}",
    "collapseFeed": "Hide records in {{feed}}",
    "feedPreviewFailed": "This category's records could not be loaded.",
    "feedPreviewEmpty": "No records in this category match these filters.",
    "feedShowAll": "Show all in this category",
    "feedChip": "Category: {{feed}}",
    "notUsedYet": "Not used yet",
    "usedIn": "Used in {{records}}",
    "feed": "Category",
    "latestSource": "Latest source {{when}}",
    "moreAvailable": "More results are available.",
    "noLessonsTitle": "No lessons in this view yet",
    "noLessonsMessage": "Collected evidence is available separately. A lesson appears here after it is published; try another scope or inspect the evidence.",
    "noLessonsFilteredMessage": "No lesson matches these filters.",
    "noEvidenceTitle": "No evidence in this view yet",
    "noEvidenceMessage": "Evidence appears here as your source connections collect it. Check your sources if you expected some.",
    "noEvidenceFilteredMessage": "No evidence matches these filters.",
    "noBatchTitle": "No matches in this batch",
    "noBatchMessage": "Choose Next to keep looking, or narrow the service and type filters.",
    "usageRetrieved": "Lessons retrieved by agents · last 30 days",
    "usageHelpful": "Lessons marked helpful · last 30 days",
    "todayCollected": "Documents collected today (UTC)",
    "todayRetrieved": "Records retrieved today (UTC)",
    "todayApproved": "Lessons approved today (UTC)"
  },
  "table": {
    "lesson": "Lesson",
    "record": "Record",
    "feed": "Category",
    "status": "Status",
    "sources": "Sources",
    "scope": "Scope",
    "links": "Connections",
    "recorded": "Recorded",
    "provider": "Provider",
    "latestSource": "Latest source"
  },
  "feeds": {
    "documents": "Documents",
    "documentsDescription": "Collected source documents.",
    "governance_decisions": "Governance decisions",
    "governance_decisionsDescription": "How governance policy answered each selected agent’s tool requests, totalled per collection.",
    "governance_decision_records": "Earlier individual decisions",
    "governance_decision_recordsDescription": "Single decisions from before totals, kept because a lesson, proposal or investigation cites them.",
    "governance_configuration": "Governance configuration",
    "governance_configurationDescription": "Registered agents and policy summaries.",
    "log_distillation": "Log distillation",
    "log_distillationDescription": "Patterns, counts, and comparisons from collected logs.",
    "query_export": "Observations",
    "query_exportDescription": "Collected queries, logs, and telemetry.",
    "incident_export": "Incidents",
    "incident_exportDescription": "Incident timelines and recorded responses.",
    "deployment_config": "Configuration",
    "deployment_configDescription": "Resource and deployment configuration.",
    "catalog": "Service catalog",
    "catalogDescription": "Service ownership and dependencies.",
    "runbook": "Runbooks",
    "runbookDescription": "Operating procedures and recovery checks.",
    "postmortem": "Postmortems",
    "postmortemDescription": "Incident findings and follow-up documents."
  },
  "detail": {
    "loadFailedTitle": "Details could not be loaded",
    "reusableLesson": "Reusable lesson",
    "tabs": {
      "overview": "Overview",
      "connections": "Connections",
      "evidence": "Evidence",
      "history": "History"
    },
    "trailLabel": "How you got here",
    "withdrawnTitle": "This memory has been withdrawn",
    "checkApplicabilityTitle": "Check applicability before reuse",
    "checkApplicabilityMessage": "Its current status limits reuse. Agents must check current validity before relying on it.",
    "truncatedExcerpt": "Only a shortened excerpt was stored. A complete chart or comparison cannot be drawn from it.",
    "whatHappened": "What happened",
    "fact": "Fact",
    "contents": "Contents",
    "rawObservation": "Raw observation",
    "noSummary": "No summary recorded.",
    "latestObservationNote": "Viewing the latest authorized observation. Older observations remain separate from the evidence a lesson cited.",
    "observationHistory": "Observations & changes",
    "appliesTo": "Applies to",
    "architectureRevision": "Architecture revision",
    "notSpecified": "Not specified",
    "knowledgeStatus": "Knowledge status",
    "conditions": "Conditions",
    "noConditions": "No explicit conditions recorded. Verify the scope before reuse.",
    "limitations": "Limitations",
    "investigationOutcome": "Investigation outcome",
    "captureCompleteness": "Capture completeness: {{value}}",
    "symptom": "Symptom",
    "summary": "Summary",
    "failedAttempts": "Failed attempts",
    "rejectedHypotheses": "Rejected hypotheses",
    "recoveryVerification": "Recovery verification",
    "verificationWindow": "window {{window}}",
    "candidateLessons": "Candidate lessons",
    "candidateNote": "Candidates have not been published as reusable knowledge.",
    "whatObserved": "What was observed",
    "sourceHeading": "Source",
    "collected": "Collected",
    "sourceRevision": "Source revision",
    "viewSourceDocument": "View source document",
    "citedBy": "Cited by",
    "notCited": "No lesson cites this yet.",
    "viewConnections": "View connections",
    "useWhen": "Use this when",
    "dontRelyWhen": "Don't rely on it when",
    "noLimitations": "No limitations recorded.",
    "evidence": "Evidence",
    "viewAllEvidence": "View all {{count}}",
    "scope": "Scope",
    "details": "Details",
    "whySupportedNote": "Evidence cited by this lesson. A fresh collection is not an additional independent source.",
    "noReadableEvidence": "No cited evidence is readable with your current access.",
    "localMock": "Local mock source",
    "withdrawn": "Withdrawn",
    "stale": "Stale",
    "usage": {
      "title": "Use by agents",
      "retrieved": "Retrieved in the last 30 days",
      "times": "{{count}} time",
      "times_plural": "{{count}} times",
      "lastRetrieved": "Last retrieved",
      "never": "Never",
      "noFeedback": "No agent feedback yet.",
      "helpful": "Helpful",
      "not_helpful": "Not helpful",
      "wrong": "Wrong",
      "outdated": "Outdated",
      "agent": "agent"
    },
    "provenance": {
      "title": "Provenance",
      "recordId": "Record ID",
      "version": "Version",
      "knowledgeRevision": "Knowledge revision",
      "investigation": "Originating investigation",
      "agent": "Originating agent",
      "recordedBy": "Recorded by",
      "recorded": "Recorded",
      "access": "Access",
      "origins": "Origins"
    },
    "lineage": {
      "title": "How this lesson formed",
      "excerpts": "{{count}} excerpt",
      "excerpts_plural": "{{count}} excerpts",
      "collectedEvidence": "Collected evidence",
      "proposed": "Proposed",
      "draftFromEvidence": "Draft from evidence",
      "approved": "Approved",
      "byReviewer": "By a reviewer",
      "review": "Review",
      "noApproval": "No approval recorded",
      "lesson": "Lesson",
      "reusable": "Reusable in scope"
    },
    "history": {
      "version": "Version {{version}} · {{lifecycle}}",
      "reviewBy": "{{decision}} · {{who}}",
      "reviewer": "Reviewer",
      "emptyTitle": "No version history yet",
      "emptyMessage": "Recorded versions and review decisions will appear here."
    }
  },
  "standing": {
    "title": "Change this lesson's standing",
    "note": "Mark it disputed or superseded when evidence changes, or archive it. Each change is versioned and audited; agents see the new status on their next search.",
    "change": "Change standing",
    "newStanding": "New standing",
    "reason": "Reason",
    "record": "Record change",
    "still_supported": "Still supported",
    "resolvesDispute": "Supported (resolves the dispute)",
    "disputed": "Disputed",
    "superseded": "Superseded",
    "archive": "Archive",
    "recorded": "Recorded. The lesson is now {{epistemic}} and {{freshness}}.",
    "conflict": "Someone changed this lesson first. Review the latest version before deciding again.",
    "failed": "The standing could not be recorded."
  },
  "promotion": {
    "title": "Promote to a reusable lesson",
    "ineligible": "This record is not eligible for a promotion with your current access.",
    "intro": "Draft a lesson from this investigation. It keeps the same scope and goes through admission before publication.",
    "draft": "Draft a lesson",
    "draftTitle": "Draft a reusable lesson",
    "scopeNote": "Scope stays {{scope}}. Submission creates a proposal and runs admission; it does not directly publish the record.",
    "statement": "Lesson",
    "claimType": "Claim type",
    "sourceVersion": "Source version",
    "conditions": "Conditions · one per line",
    "limitations": "Limitations · one per line",
    "attachEvidence": "Attach supporting evidence",
    "noEvidence": "No readable evidence is available. Admission may hold this proposal until evidence is attached.",
    "acknowledge": "Submit this draft to the configured {{judge}} judge{{model}}{{mode}}. The service records the resulting decision.",
    "liveModel": " using a live model call",
    "fixtureModel": " using a fixture assessment",
    "submit": "Submit for admission",
    "submitting": "Submitting…",
    "cancel": "Cancel",
    "needEvidence": "Attach at least one supporting evidence record before submitting.",
    "tooLong": "Use up to 20 conditions and limitations, with no more than 500 characters per line.",
    "submitted": "Lesson submitted for admission. Status: {{status}}.",
    "openQueue": "Open the review queue",
    "conflict": "This record changed while you were drafting. Review the latest version and create a new draft.",
    "draftFailed": "The lesson draft could not be prepared.",
    "submitFailed": "The lesson could not be submitted.",
    "claimTypes": {
      "diagnostic_observation": "Diagnostic observation",
      "causal_explanation": "Causal explanation",
      "remediation_advice": "Remediation advice",
      "action_precondition": "Action precondition",
      "procedure": "Procedure"
    }
  }
}
